export default "__VITE_ASSET__CEbfQbXr__"